import { LogoDefinition } from '../types';

export const brandLogoNegative: LogoDefinition = {
  id: 'brandLogoNegative',
  width: 190,
  height: 88,
  svgContent: [
    {
      type: 'rect',
      fill: '#0445a5',
      height: '88',
      width: '190',
    },
    {
      type: 'path',
      fill: '#f8b400',
      data: 'M79.7749 38.9051C83.9609 38.9051 87.3544 35.5117 87.3544 31.3256C87.3544 27.1396 83.9609 23.7461 79.7749 23.7461C75.5888 23.7461 72.1953 27.1396 72.1953 31.3256C72.1953 35.5117 75.5888 38.9051 79.7749 38.9051Z',
    },
    {
      type: 'path',
      fill: 'white',
      data: 'M36.3308 40.6123H22V64.2293H28.7513V45.6821H34.6493C36.0548 45.6821 37.1842 46.8115 37.1842 48.2169V64.2544H43.9355V48.2169C43.9355 44.0005 40.5222 40.6123 36.3308 40.6123Z',
    },
    {
      type: 'path',
      fill: 'white',
      data: 'M110.57 59.1595H106.153C104.848 59.0591 103.819 57.9799 103.819 56.6246V45.6569H110.57V40.5872H103.819V32.1543H97.0677V40.5872H94.1062L90.3164 45.6569H97.0677V56.6497C97.0677 60.8411 100.456 64.2293 104.647 64.2293H110.545V61.4183L110.57 59.1595Z',
    },
    {
      type: 'path',
      fill: 'white',
      data: 'M92.4487 40.6123H84.844L79.7994 47.3636L74.7296 40.6123H67.125L75.9845 52.4083L67.125 64.2293H74.7296L79.7994 57.478L84.844 64.2293H92.4487L83.5891 52.4083L92.4487 40.6123Z',
    },
    {
      type: 'path',
      fill: 'white',
      data: 'M139.231 40.6123L133.333 55.6459L127.435 40.6123H120.684L129.97 64.2293H136.696L145.982 40.6123H139.231Z',
    },
    {
      type: 'path',
      fill: 'white',
      data: 'M119.003 40.6113H112.252V64.2283H119.003V40.6113Z',
    },
    {
      type: 'path',
      fill: 'white',
      data: 'M119.003 32.1787H112.252V38.93H119.003V32.1787Z',
    },
    {
      type: 'path',
      fill: 'white',
      data: 'M57.4128 59.1583C55.2795 59.1583 53.4725 57.4015 52.7196 54.9419H68.9578C69.1335 54.1387 69.2339 53.2854 69.2339 52.407C69.2339 45.8816 63.9383 40.5859 57.4128 40.5859C50.8874 40.5859 45.5918 45.8816 45.5918 52.407C45.5918 58.9324 50.8874 64.2281 57.4128 64.2281H65.419L69.2088 59.1583H57.4128ZM57.4128 45.6808C59.5462 45.6808 61.3532 47.4376 62.1061 49.8972H52.7196C53.4725 47.4125 55.3046 45.6808 57.4128 45.6808Z',
    },
    {
      type: 'path',
      fill: 'white',
      data: 'M159.964 40.6123H147.666L145.683 45.6821H158.282C159.687 45.6821 160.817 46.8115 160.817 48.2169V49.8985H150.702V49.9236C146.938 50.1495 143.951 53.2616 143.951 57.0764C143.951 60.8913 146.938 64.0034 150.702 64.2293V64.2544H167.568V48.2169C167.543 44.0005 164.155 40.6123 159.964 40.6123ZM152.384 54.9933C152.51 54.9682 152.635 54.9682 152.735 54.9431H160.817V59.1596H157.981H152.76C152.635 59.1596 152.51 59.1345 152.409 59.1094C151.455 58.9086 150.728 58.0553 150.728 57.0513C150.728 56.0474 151.405 55.1941 152.384 54.9933Z',
    },
  ],
};
